import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContext } from '../Contexts';
import { FilterBaseRequest, FileItem, FilesResponse, FileUsageResponse, ToastFailureMessage, ToastSuccessMessage } from '../Models/Models';
import HttpRepository from './HttpRepository';

export function FileService() {
    const navigate = useNavigate();
    const { setToast }: any = useContext(ToastContext);

    async function uploadFiles(formData: FormData, isPopUp = false): Promise<FileItem[] | undefined> {
        let uploaded: FileItem[];
        try {
            uploaded = (await HttpRepository.uploadFiles(formData)).data;
        } catch {
            setToast({ message: ToastFailureMessage.dataNotSaved });
            return undefined;
        }
        setToast({ message: ToastSuccessMessage.dataSaved });
        if (!isPopUp) navigate('/file/table');
        return uploaded;
    }

    async function filterFiles(request: FilterBaseRequest): Promise<FilesResponse> {
        try {
            return (await HttpRepository.filterFiles(request)).data;
        } catch {
            setToast({ message: ToastFailureMessage.dataNotLoaded });
        }
    }

    async function deleteFile(id: number): Promise<void> {
        try {
            await HttpRepository.deleteFile(id);
        } catch (error) {
            setToast({ message: ToastFailureMessage.changesNotSaved });
            throw error;
        }
        setToast({ message: ToastSuccessMessage.changesSaved });
    }

    async function checkFileUsage(id: number): Promise<FileUsageResponse> {
        try {
            return (await HttpRepository.checkFileUsage(id)).data;
        } catch {
            setToast({ message: ToastFailureMessage.dataNotLoaded });
        }
    }

    async function editFileName(fileId: number, newFileName: string): Promise<void> {
        try {
            await HttpRepository.editFileName(fileId, newFileName);
        } catch (error) {
            setToast({ message: ToastFailureMessage.changesNotSaved });
            throw error;
        }
        setToast({ message: ToastSuccessMessage.changesSaved });
    }

    return { uploadFiles, filterFiles, deleteFile, checkFileUsage, editFileName };
}
